<template>
  <div class="enter-guard">
    <div class="ly-card search-content">
      <div class="btn-group flex">
        <el-button size="medium" @click="exportExcel">导出</el-button>
        <advanced-query @search="search" />
      </div>
      <div class="search-group flex">
        <div class="flex-1 m-r-10">
          <el-date-picker
            v-model="searchFormData.modify_time"
            type="daterange"
            unlink-panels
            range-separator="至"
            start-placeholder="修改开始日期"
            end-placeholder="修改结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </div>
        <el-input
          placeholder="班级名称/代码/预约号/学员姓名/身份证号"
          v-model.trim="searchFormData.query"
          @keydown.native.enter="() => search()"
        />
        <el-button type="primary" size="medium" @click="() => search()">查询</el-button>
      </div>
    </div>
    <div class="ly-card">
      <ly-table
        :tableConfig="tableConfig"
        :getTableData="getTableData"
        :tableHeader="tableHeader"
        :searchFormData="searchFormData"
        class="diy-table"
        ref="lyTable"
      >
        <template v-slot:class_name="row">
          <el-button @click="showClass(row)" type="text" size="mini">{{ row.class_name }}</el-button>
        </template>
        <template v-slot:org_full_name="row">{{
          row.org_full_name && row.org_full_name.replace(/中国儿童中心\/+/, '')
        }}</template>
        <template v-slot:reservation_number="row">
          <el-button type="text" class="reservation-number" size="small" @click="() => openInf(row)">{{
            row.reservation_number
          }}</el-button>
        </template>
        <template v-slot:id_card_type="row">
          {{ row.id_card_type === 1 ? '身份证' : '其他' }}
        </template>
        <template v-slot:user_type="row">
          {{ row | userType }}
        </template>
        <template v-slot:action>
          <el-button type="text" size="mini">编辑</el-button>
        </template>
      </ly-table>
    </div>
    <el-dialog title="课程表" :visible.sync="dialogVisibleSc" width="1400px">
      <class-schedule :class_mode="scTime.class_mode" :class_id="scTime.class_id" />
    </el-dialog>
    <el-dialog title="班级信息" :visible.sync="dialogVisibleDetail" width="1000px">
      <class-inf-detail-list
        :isFetch="true"
        @showSc="showSc"
        :defaultFormItemClass="defaultFormItemClass"
      ></class-inf-detail-list>
    </el-dialog>
    <pay-detail
      ref="payDetail"
      :sign_up_id="curItem.sign_up_id"
      :def="curItem"
      :class_id="curItem.class_id"
      :contact_id="curItem.contact_id"
      :buttons="[]"
      @success="search"
    />
  </div>
</template>
<script>
import { Dialog, Input, DatePicker } from 'element-ui';

import LyTable from '@/components/LyTable';
import { guardTable } from '@/utils/tableHeaderClass';
import { classApi } from '@/api';
import ClassInfDetailList from '@/components/ClassInfDetail/list';
import ClassSchedule from '@/components/ClassSchedule';
import AdvancedQuery from '@/components/AdvancedQuery';
import PayDetail from '@/components/PayDetail';
import utils from '@/utils/utils';

export default {
  name: 'Guard',
  components: {
    ElDialog: Dialog,
    ElInput: Input,
    LyTable,
    ClassInfDetailList,
    ClassSchedule,
    AdvancedQuery,
    PayDetail,
    ElDatePicker: DatePicker
  },
  data() {
    return {
      searchFormData: {
        query: '',
        modify_time: [],
        sorted_title: 'modify_time',
        sorted_type: 'DESC'
      },
      tableHeader: guardTable,
      getTableData: classApi.getAccessControl,
      tableConfig: {
        action: {
          'selection-change': selection => {
            this.selection = selection;
          }
        }
      },
      curItem: {
        class_id: 0,
        contact_id: 0,
        sign_up_id: 0
      },
      dialogVisible: false,
      dialogVisibleSc: false,
      dialogVisibleDetail: false,
      scTime: {},
      defaultFormItemClass: {}
    };
  },
  mounted() {
    this.search();
  },
  filters: {
    userType(row) {
      if (row.id_card_type === 1) {
        const { id_card_no } = row;
        let birthday = '';
        if (!id_card_no) return '一';
        if (id_card_no.length === 15) {
          birthday = `19${id_card_no.substr(6, 6)}`;
        } else if (id_card_no.length === 18) {
          birthday = id_card_no.substr(6, 8);
        } else {
          return '';
        }
        birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-');
        return new Date().getFullYear() - new Date(birthday).getFullYear() >= 18 ? '成人' : '孩子';
      }
      return '一';
    }
  },
  methods: {
    handleTabsClick() {
      this.search();
    },
    search(data) {
      if (this.searchFormData.modify_time && this.searchFormData.modify_time.length) {
        this.searchFormData = {
          ...this.searchFormData,
          ...data,
          modify_start_time: this.searchFormData.modify_time[0],
          modify_end_time: this.searchFormData.modify_time[1]
        };
      } else {
        delete this.searchFormData.modify_start_time;
        delete this.searchFormData.modify_end_time;
      }
      this.searchFormData = { ...this.searchFormData, ...data };
      this.$refs.lyTable.setData();
    },
    showSc(row) {
      this.dialogVisibleSc = true;
      this.scTime = {
        class_mode: row.class_mode,
        class_id: row.class_id
      };
    },
    showClass(row) {
      this.defaultFormItemClass = { id: row.class_id };
      this.dialogVisibleDetail = true;
    },
    openInf(row) {
      this.curItem = { ...row };
      this.$refs.payDetail.open();
    },
    async saveForm() {
      const { data, valid } = await this.$refs.lyForm.getFormData();
      if (valid) {
        classApi
          .updateMailInfo({
            id: this.defaultFormItemClass.id,
            params: data
          })
          .then(res => {
            if (res && res.data) {
              this.search();
            }
          });
      }
    },
    finish(row) {
      classApi
        .batchUpdateMail({
          params: {
            mail_info_ids: [row.id],
            mail_status: true
          }
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '邮寄成功！');
            this.search();
          }
        });
    },
    exportExcel() {
      classApi.exportAccessControl({ params: this.searchFormData }).then(data => {
        if (data) utils.downloadData(data, '门禁信息');
      });
    }
  }
};
</script>
<style lang="less">
.enter-guard {
  .search-content {
    display: flex;
    justify-content: space-between;
    .search-group .el-input {
      width: 285px;
      margin-right: 20px;
    }
  }
}
</style>
